import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import React from "react";
import DefaultButton from "../styles/materialButtonStyle";
import ValidationFormControl from "../styles/materialValidFormControl";
import { StyledForm, StyledFormAction, StyledFormContent } from "../styles/styledForm";

const ForgotPasswordForm = ({ t, handleSubmit, loading }) => {

  return (
    <>
      <StyledForm
        onSubmit={handleSubmit}
        className="login-form"
      >
        <StyledFormContent className="login-form__content">
          <ValidationFormControl
            className="login-form__input"
          >
            <InputLabel htmlFor="eMail">E-mail</InputLabel>
            <Input
              id="eMail"
              required
              type="email"
              name="email"
            />
          </ValidationFormControl>
        </StyledFormContent>
        <StyledFormAction className="login-form__action">
          <DefaultButton
            color="success"
            type="submit"
            disabled={loading}
          >
            {t("submit")}
          </DefaultButton>
        </StyledFormAction>
      </StyledForm>
    </>
  );
};

export default ForgotPasswordForm;